export enum UnleashFlags {
  AssignmentsPlayerQuestionDeletable = 'next.service.assignments_player.question_deletable',
  UseDigibookIcon = 'next.service.use_digibook_icon',
  RecentsDeletable = 'next.service.recents.recents_deletable',
  NextLearningGoals = 'next.learning_goals',
  WebSockets = 'next.websockets',
  AddDemoGroup = 'next.add_demo_group',
  PocChatbot = 'poc.chatbot',
  UseVestaArrangements = 'next.use_vesta.arrangements',
  UseVestaArrangementByCode = 'next.use_vesta.arrangement_by_code',
  UseVestaSaveArrangement = 'next.use_vesta.save_arrangement',
  UseVestaCreateArrangement = 'next.use_vesta.create_arrangement',
  UseVestaVdexDefinition = 'next.use_vesta.vdex_definition',
  UseVestaClusters = 'next.use_vesta.clusters',
  UseVestaClusterByMethodSlug = 'next.use_vesta.cluster_by_method_slug',
  UseVestaResourcesByArrangementCode = 'next.use_vesta.resources_by_arrangement_code',
  UseVestaResourcesByMethodSlug = 'next.use_vesta.resources_by_method_slug',
  UseVestaMultipleResources = 'next.use_vesta.multiple_resources',
  UseVestaMethods = 'next.use_vesta.methods',
  UseVestaMethodBySlug = 'next.use_vesta.method_by_slug',
  UseVestaContentById = 'next.use_vesta.content_by_id',
  UseVestaRawContentById = 'next.use_vesta.raw_content_by_id',
  UseVestaContentByPath = 'next.use_vesta.content_by_path',
  AdaptiveScores = 'next.adaptive_scores',
  CommunityPlatformButton = 'next.community_platform_button',
  UseInteractionFocusMode = 'next.interaction_player_focus_mode',
  NextResults = 'next.results',
  ResourcesOnContentIdentifier = 'resources_on_contentIdentifier',
  ResultsDetailContextMenuEnabled = 'results_detail_context_menu_enabled',
  GetFeedbackThor = 'next.get_feedback_thor',
  CreateFeedbackThor = 'next.create_feedback_thor',
}

export enum UnleashContext {
  MethodSlug = 'methodSlug',
  LearningLevel = 'learningLevel',
  ArrangementCode = 'arrangementCode',
  ArrangementType = 'arrangementType',
  PublicationSource = 'publicationSource',
  UserReference = 'userReference',
  Cpis = 'cpis',
  BrinCode = 'brinCode',
}
